import * as React from 'react';

import { Image } from '../Image';

const icon = require('../../assets/terminal-icon.png');

export function TerminalIcon(props: Partial<React.ComponentProps<typeof Image>>) {
  return <Image source={icon} {...props} />;
}
